import { FileToImport } from '~/front-models/fileToImport';

type importFileMap = Record<string, FileToImport>;

export const importFileMapOptions: importFileMap = {
  
  'departments': {
    modelName: 'Departments',
    labelName: 'Departments',
    columns: [
      {
        name: 'code',
        label: 'Department Code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      },
      {
        name: 'name',
        label: 'Department Name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      }
    ]
  },
  'persons':{
    modelName: 'Persons',
    labelName: 'persons',
    columns: [
      {
        name: 'department',
        label: 'Department ID',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'manager',
        label: 'Manager Person ID',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'site',
        entityRelation: 'OneToOne',
        name: 'code',
        label: 'User Sites',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',

      },
    ]
  },
  'facility': {
    modelName: 'Facility',
    labelName: 'Facility',
    columns: [
      {
        name: 'code',
        label: 'Facility',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        required: true
      },
      {
        name: 'description',
        label: 'Facility Description',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
    ],
  },
  'addresses': {
    modelName: 'Addresses',
    labelName: 'Adresses',
    columns: [
      {
        name: 'name',
        label: 'address name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        required: true
      },
      {
        name: 'addressLine1',
        label: 'address line 1',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'addressLine2',
        label: 'address line 2',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'city',
        label: 'city',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'country',
        label: 'country',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'phone1',
        label: 'Phone1',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'phone2',
        label: 'Phone2',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'state',
        label: 'state',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'zip',
        label: 'zip',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'email',
        label: 'Email',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'fax',
        label: 'Fax',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'website',
        label: 'Website',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },

    ],
  },
  'locationTypes': {
    modelName: 'Location Type',
    labelName: 'locationTypes',
    columns: [
      {
        name: 'code',
        label: 'Location Type ID',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      },
      {
        name: 'description',
        label: 'Location Type Description',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      }
    ]
  },
  'locations': {
    modelName: 'Location',
    labelName: 'locations',
    columns: [
      {
        name: 'code',
        label: 'Location ID',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        required: true
      },
      {
        name: 'description',
        label: 'Location Description',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'locationType',
        entityRelation: 'OneToOne',
        //name: 'locationTypeCode',
        name: 'code',
        label: 'Location Type ID',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'code'
        relatedDbField: 'locationTypeId'
      },
      {
        entity: 'address',
        entityRelation: 'OneToOne',
        name: 'name',
        label: 'Address Name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'name'
        relatedDbField: 'addressId'
      },
      {
        entity: 'entityPallet',
        entityRelation: 'OneToOne',
        name: 'code',
        label: 'Pallet #',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'code'
      },
      // {
      //   entity: 'entityPallet',
      //   entityRelation: 'OneToOne',
      //   name: 'currentLocation',
      //   label: 'Pallet Location',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',
      //   fieldName: 'code'
      // },
      // {
      //   entity: 'entityPallet',
      //   entityRelation: 'OneToOne',
      //   name: 'homeLocation',
      //   label: 'Pallet Home Location',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',
      //   fieldName: 'code'
      // },
      {
        entity: 'entityTruck',
        entityRelation: 'OneToOne',
        name: 'truckMake',
        label: 'Vehicle Make',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityTruck',
        entityRelation: 'OneToOne',
        name: 'truckModel',
        label: 'Vehicle Model',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityTruck',
        entityRelation: 'OneToOne',
        name: 'truckColor',
        label: 'Vehicle Color',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityTruck',
        entityRelation: 'OneToOne',
        name: 'truckVin',
        label: 'Vehicle Vin',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityTruck',
        entityRelation: 'OneToOne',
        name: 'truckLicensePlate',
        label: 'Vehicle License Plate',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityTruck',
        entityRelation: 'OneToOne',
        name: 'homeLocation',
        label: 'Home Location',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        fieldName: 'code',
        relatedDbField: 'entityTruck.homeLocationId'
      },
      {
        entity: 'entityTruck',
        entityRelation: 'OneToOne',
        name: 'currentLocation',
        label: 'Current Location',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        fieldName: 'code',
        relatedDbField: 'entityTruck.currentLocationId'
      },
      {
        entity: 'facility',
        entityRelation: 'OneToOne',
        name: 'code',
        label: 'Facility ID',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        required: true,
        relatedDbField: 'facilityId'
      },
      {
        entity: 'building',
        entityRelation: 'OneToOne',
        name: 'description',
        label: 'Building',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'code'
        relatedDbField: 'buildingId'
      },
      {
        entity: 'floor',
        entityRelation: 'OneToOne',
        name: 'description',
        label: 'Floor',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'code'
        relatedDbField: 'floorId'
      },
      {
        entity: 'site',
        entityRelation: 'OneToOne',
        name: 'code',
        label: 'Site Code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
       // fieldName: 'name'
      },
      {
        entity: 'entityStationary',
        entityRelation: 'OneToOne',
        name: 'area',
        label: 'Area',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityStationary',
        entityRelation: 'OneToOne',
        name: 'shelf',
        label: 'Shelf',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityStationary',
        entityRelation: 'OneToOne',
        name: 'room',
        label: 'Room',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityStationary',
        entityRelation: 'OneToOne',
        name: 'aisle',
        label: 'Aisle',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityStationary',
        entityRelation: 'OneToOne',
        name: 'bin',
        label: 'Bin',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },



    ],
  },
  'categories': {
    modelName: 'Category',
    labelName: 'categories',
    columns: [
      {
        name: 'code',
        label: 'category code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        required: true
      },
      {
        name: 'description',
        label: 'category description',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
    ],
  },
  'uom': {
    modelName: 'UOMs',
    labelName: 'UnitOfMeasures',
    columns: [
      {
        name: 'name',
        label: 'uom name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        required: true
      },
      {
        name: 'code',
        label: 'uom code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        required: true
      },
      {
        name: 'multiplier',
        label: 'uom multiplier',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric',
        required: true
      },
    ],
  },
  'vendors': {
    modelName: 'Vendor',
    labelName: 'vendors',
    columns: [
      {
        name: 'name',
        label: 'vendor name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        required: true
      },
      {
        name: 'code',
        label: 'vendor code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        required: true
      },
      {
        entity: 'entityContract',
        entityRelation: 'OneToOne',
        name: 'number',
        label: 'contract #',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityContract',
        entityRelation: 'OneToOne',
        name: 'certdate',
        label: 'Vendor Certification Date',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'date',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'AddressLine1',
        label: 'address line1',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'AddressLine2',
        label: 'Address Line2',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'city',
        label: 'City',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'state',
        label: 'state',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'zip',
        label: 'zip',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'country',
        label: 'country',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'phone1',
        label: 'Phone 1',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'phone2',
        label: 'Phone 2',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'fax',
        label: 'Fax',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },

      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'email',
        label: 'Email',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },

      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'website',
        label: 'Website',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityContact',
        entityRelation: 'OneToOne',
        name: 'phone1',
        label: 'contact phone 1',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityContact',
        entityRelation: 'OneToOne',
        name: 'phone2',
        label: 'contact phone 2',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityContact',
        entityRelation: 'OneToOne',
        name: 'fax',
        label: 'contact fax',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityContact',
        entityRelation: 'OneToOne',
        name: 'email',
        label: 'contact email',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityContact',
        entityRelation: 'OneToOne',
        name: 'website',
        label: 'contact website',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'notes',
        label: 'Notes',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityContact',
        entityRelation: 'OneToOne',
        name: 'person',
        label: 'Contact',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
    ],
  },
  'customers': {
    modelName: 'Customers',
    labelName: 'Customers',
    columns: [
      {
        name: 'name',
        label: 'customer name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        required: true
      },
      {
        name: 'code',
        label: 'customer code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        required: true
      },
      {
        entity: 'customerType',
        entityRelation: 'OneToOne',
        name: 'code',
        label: 'Customer Type Code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        relatedDbField: 'customerTypeId'
      },
      {
        entity: 'customerType',
        entityRelation: 'OneToOne',
        name: 'name',
        label: 'Customer Type Name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        relatedDbField: 'customerTypeId'
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'addressLine1',
        label: 'address line1',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {

        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'addressLine2',
        label: 'address line2',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {

        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'fax',
        label: 'fax',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {

        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'phone1',
        label: 'Phone 1',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {

        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'phone2',
        label: 'Phone 2',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {

        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'city',
        label: 'city',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'state',
        label: 'state',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'zip',
        label: 'zip',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'country',
        label: 'country',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'email',
        label: 'email',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityAddress',
        entityRelation: 'OneToOne',
        name: 'website',
        label: 'Website',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityTruck',
        entityRelation: 'OneToOne',
        name: 'Truckcolor',
        label: 'Vehicle color',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityTruck',
        entityRelation: 'OneToOne',
        name: 'Trucklicenseplate',
        label: 'Vehicle license plate',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityTruck',
        entityRelation: 'OneToOne',
        name: 'Truckvin',
        label: 'Vehicle Vin',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityTruck',
        entityRelation: 'OneToOne',
        name: 'Truckmodel',
        label: 'Vehicle Model',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityTruck',
        entityRelation: 'OneToOne',
        name: 'Truckmake',
        label: 'Vehicle Make',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'customerContract',
        entityRelation: 'OneToOne',
        name: 'date',
        label: 'Contract Date',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'date',
      },
      {
        entity: 'customerContract',
        entityRelation: 'OneToOne',
        name: 'expireDate',
        label: 'Contract Expired Date',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'date',
      },
      {
        entity: 'customerContract',
        entityRelation: 'OneToOne',
        name: 'customerWithCode',
        label: 'Contract Customer',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        relatedDbField: 'customerContract.customerWithId'
      },
      {
        entity: 'entityContact',
        entityRelation: 'OneToOne',
        name: 'email',
        label: 'contact email',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityContact',
        entityRelation: 'OneToOne',
        name: 'fax',
        label: 'contact fax',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityContact',
        entityRelation: 'OneToOne',
        name: 'phone1',
        label: 'contact phone 1',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityContact',
        entityRelation: 'OneToOne',
        name: 'phone2',
        label: 'contact phone 2',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'entityContact',
        entityRelation: 'OneToOne',
        name: 'person',
        label: 'Contact',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
    ],
  },
  'disposeTo': {
    modelName: 'Dispose To',
    labelName: 'disposeTo',
    columns: [
      {
        name: 'code',
        label: 'Dispose To ID',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      },
      {
        name: 'description',
        label: 'Dispose To Name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      }
    ]
  },
  'stockItems': {
    modelName: 'Stock Item',
    labelName: 'stockItems',
    columns: [
      {
        name: 'number',
        label: 'Stock Item',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        required: true
      },
      {
        name: 'description',
        label: 'Stock Description',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'costType',
        entityRelation: 'OneToOne',
        name: 'code',
        label: 'Cost Type',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'code',
        relatedDbField: 'costTypeId'
      },
      {
        entity: 'defaultLocation',
        entityRelation: 'OneToOne',
        name: 'code',
        label: 'Default Location Id',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'code',
        relatedDbField: 'defaultLocationId'
      },
      {
        name: 'generalDescription',
        label: 'General Description',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'itemType',
        entityRelation: 'OneToOne',
        name: 'name',
        label: 'Item type Code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'name',
        relatedDbField: 'itemTypeId'
      },
      {
        entity: 'issueUnitOfMeasure',
        entityRelation: 'OneToOne',
        name: 'code',
        label: 'Issue UOM Code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
       // fieldName: 'code',
       relatedDbField: "issueUnitOfMeasureId"
      },
      {
        entity: 'issueUnitOfMeasure',
        entityRelation: 'OneToOne',
        name: 'unitName',
        label: 'Issue UOM Name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'unitName',
      },
      {
        entity: 'receiveUnitOfMeasure',
        entityRelation: 'OneToOne',
        name: 'code',
        label: 'Received UOM Code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'code',
        relatedDbField: "receiveUnitOfMeasureId"
      },
      {
        entity: 'receiveUnitOfMeasure',
        entityRelation: 'OneToOne',
        name: 'unitName',
        label: 'Received UOM Name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'unitName',
      },
      {
        entity: 'inventoryUnitOfMeasure',
        entityRelation: 'OneToOne',
        name: 'code',
        label: 'Inventory UOM Code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'code',
        relatedDbField: "inventoryUnitOfMeasureId"
      },
      {
        entity: 'inventoryUnitOfMeasure',
        entityRelation: 'OneToOne',
        name: 'unitName',
        label: 'Inventory UOM Name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'unitName',
      },
      // {
      //   name: 'PRICEMARKUPPERCENTAGE',
      //   label: 'Price Markup %',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'numeric',
      // },
      {
        entity: 'costInfo',
        entityRelation: 'OneToOne',
        name: 'markupPercent',
        label: 'Price Markup %',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric',
        //fieldName: 'cost',

      },
      // {
      //   name: 'PRICEMARKUP',
      //   label: 'Price Markup $',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'numeric',
      // },
      {
        entity: 'costInfo',
        entityRelation: 'OneToOne',
        name: 'markupNumber',
        label: 'Price Markup $',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric',
        //fieldName: 'cost',
      },

      {
        entity: 'costInfo',
        entityRelation: 'OneToOne',
        name: 'markupType',
        label: 'Markup Type',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'costInfo',
        entityRelation: 'OneToOne',
        name: 'fixedUnitPrice',
        label: 'Price',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric',
      },
      {
        entity: 'costInfo',
        entityRelation: 'OneToOne',
        name: 'cost',
        label: 'Cost',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric',
        //fieldName: 'cost',
      },
      {
        entity: 'category',
        entityRelation: 'OneToOne',
        name: 'code',
        label: 'Category Code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
       // fieldName: 'code',
       relatedDbField: "categoryId"
      },
      {
        entity: 'category',
        entityRelation: 'OneToOne',
        name: 'description',
        label: 'Category Description',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'description',
      },
      {
        name: 'minqty',
        label: 'Minimum Quantity',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric',
      },
      {
        name: 'maxqty',
        label: 'Maximum Quantity',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric',
      },
      {
        name: 'isShopping',
        label: 'is shopping',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'boolean',
      },
      {
        entity: 'stockItemLeads',
        entityRelation: 'OneToMany',
        name: 'stockitemleadtime',
        label: 'LeadTime',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric',
        //fieldName: 'stockitemleadtime'
      },
      {
        entity: 'stockItemLeads',
        entityRelation: 'OneToMany',
        name: 'stockitemleadinterval',
        label: 'Timeunit',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'stockitemleadtime'
      },
      {
        entity: 'stockItemLeads',
        entityRelation: 'OneToMany',
        name: 'stockitemleadtimeduration',
        label: 'Timeunit Code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'stockitemleadtime'
      },
      {
        entity: 'stockItemAlternates',
        entityRelation: 'OneToMany',
        name: 'code',
        label: 'master stock number',
        mappedName: 'Master Stock Number',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'stockitemleadtime'
      },

      {
        entity: 'stockItemVendors',
        entityRelation: 'OneToMany',
        name: 'code',
        label: 'Preferred Vendor',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        //fieldName: 'code'
      },

      // {
      //   entity: 'stockItemLeads',
      //   entityRelation: 'OneToMany',
      //   name: 'stockItemLeads',
      //   label: 'Lead Time',
      //   mappedName: 'Lead Time',
      //   type: 'numeric',
      //   fieldName: 'stockitemleadinterval'
      // }

    ],
  },
  'purchaseOrders':{
    modelName: 'Purchase Order',
    labelName: 'purchaseOrders',
    columns: [
      {
        name: 'poNumber',
        label: 'Purchase Order #',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      },
      {
        name: 'isClosed',
        label: 'Closed',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'boolean'
      },
      {
        entity: 'Items',
        entityRelation: 'OneToMany',
        name: 'unitsOrdered',
        label: 'Order Quantity',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        name: 'orderDate',
        label: 'Order Date',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'date'
      },
      {
        name: 'dueDate',
        label: 'Due Date',
        mappedName: '',
        mappedNameToValidate: '',
        type : 'date'
      },
      {
        name: 'expectedDeliveryDate',
        label: 'Expected Delivery Date',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'date'
      },
      {
        name: 'subtotal',
        label: 'Subtotal',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        name: 'shipping',
        label: 'Shipping',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        name: 'discount',
        label: 'Discount',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        name: 'otherAdjustment',
        label: 'Other Adjustment',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        name: 'tax',
        label: 'Tax',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        name: 'total',
        label: 'Total',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        entity: 'Items',
        entityRelation: 'OneToMany',
        name: 'lineNumber',
        label: 'Line Number',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        entity: 'Items',
        entityRelation: 'OneToMany',
        name: 'unitsReceived',
        label: 'Units Received',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        entity: 'Items',
        entityRelation: 'OneToMany',
        name: 'extendedCost',
        label: 'Extended Cost',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        entity: 'Items',
        entityRelation: 'OneToMany',
        name: 'isTaxable',
        label: 'Is Taxable',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'boolean'
      },
      {
        entity: 'vendor',
        entityRelation: 'OneToOne',
        name: 'code',
        label: 'Vendor Code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        relatedDbField: 'vendorId'

      },
      {
        entity: 'address',
        entityRelation: 'OneToOne',
        name: 'name',
        label: 'Address Name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        relatedDbField: 'addressId'
      },
      {
        entity: 'Items',
        entityRelation: 'OneToMany',
        name: 'unitCost',
        label: 'Unit Cost',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        entity: 'Items',
        entityRelation: 'OneToMany',
        name: 'stockItem',
        label: 'Stock items #',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        fieldName: 'number',
        relatedDbField: "Items.StockItemId"
      },
      // {
      //   entity: 'receiveUnitOfMeasure',
      //   entityRelation: 'OneToOne',
      //   name: 'receiveUnitOfMeasure',
      //   label: 'Received UOM Code',
      //   mappedName: 'Received UOM Code',
      //   type: 'string',
      //   fieldName: 'code',
      // },
    ]
  },
  'salesOrders': {
   modelName: 'Sales Order',
   labelName: 'salesOrders',
   columns: [
     {
       name: 'soNumber',
       label: 'Sales Order #',
       mappedName: '',
        mappedNameToValidate: '',
       type: 'string',
       required: true
     },
     {
      entity: 'stockSalesOrderStatus',
      entityRelation: 'OneToOne',
      name: 'code',
      label: 'Status',
      mappedName: '',
        mappedNameToValidate: '',
      type: 'string',
      //fieldName: 'code'
    },
    {
      entity: 'address',
      entityRelation: 'OneToOne',
      name: 'name',
      label: 'Address name',
      mappedName: '',
        mappedNameToValidate: '',
      type: 'string',
      required: true,
      relatedDbField: "addressId"
    },
    {
      //name: 'soOrderDate',
      name: 'orderDate',
      label: 'Order Date',
      mappedName: '',
        mappedNameToValidate: '',
      type: 'date',
    },
    {
      //name: 'soDueDate',
      name: 'dueDate',
      label: 'Due Date',
      mappedName: '',
        mappedNameToValidate: '',
      type: 'date',
    },
    {
      //name: 'soExpectedDeliveryDate',
      name: 'expectedDeliveryDate',
      label: 'Expected Delivery Date',
      mappedName: '',
        mappedNameToValidate: '',
      type: 'date',
    },
    {
      // entity: 'Customer',
      // entityRelation: 'OneToOne',
      name: 'notes',
      label: 'Sales Order Notes',
      mappedName: '',
        mappedNameToValidate: '',
      type: 'string'
    },
    {
      name: 'soDispatchType',
      label: 'Dispatch Type',
      mappedName: '',
        mappedNameToValidate: '',
      type: 'string',
    },
    {
      entity: 'Items',
      entityRelation: 'OneToMany',
      name: 'stockItem',
      label: 'Stock item #',
      mappedName: '',
        mappedNameToValidate: '',
      type: 'string',
      fieldName: 'number',
      relatedDbField: "Items.StockItemId"
    },
    {
      entity: 'Items',
      entityRelation: 'OneToMany',
      name: 'unitsOrdered',
      label: 'Order Quantity',
      mappedName: '',
        mappedNameToValidate: '',
      type: 'numeric',
    },
    {
      entity: 'Items',
      entityRelation: 'OneToMany',
      name: 'unitPrice',
      label: 'Unit Price',
      mappedName: '',
        mappedNameToValidate: '',
      type: 'numeric',
    },
    {
      entity: 'customer',
      entityRelation: 'OneToOne',
      name: 'code',
      label: 'Customer Code',
      mappedName: '',
        mappedNameToValidate: '',
      type: 'string',
      relatedDbField: "customerId"
    },
    // {
    //   entity: 'receiveUnitOfMeasure',
    //   entityRelation: 'OneToOne',
    //   name: 'receiveUnitOfMeasure',
    //   label: 'Received UOM Code',
    //   mappedName: 'Received UOM Code',
    //   type: 'string',
    //   fieldName: 'code',
    // },
   ],
  },
  'pickList':{
    modelName: 'Pick List',
    labelName: 'pickList',
    columns: [
      // {
      //   name: 'department',
      //   label: 'Department ID',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',
      // },
      // {
      //   name: 'manager',
      //   label: 'Manager Person ID',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',
      // },
      // {
      //   entity: 'site',
      //   entityRelation: 'OneToOne',
      //   name: 'code',
      //   label: 'User Sites',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',

      // },
    ]
  },
  'inventories': {
    modelName: 'Inventories',
    labelName: 'inventories',
    columns: [
      {
        name: 'inventoryNumber',
        label: 'Inventory Number',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      },
      {
        name: 'entryDate',
        label: 'Entry Date',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'date'
      },
      {
        name: 'expirationDate',
        label: 'Expiration Date',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'date'
      },
      {
        name: 'availability',
        label: 'Availability',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        name: 'minQuantity',
        label: 'Min Quantity',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        name: 'maxQuantity',
        label: 'Max Quantity',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric'
      },
      {
        entity: 'stockItem',
        entityRelation: 'OneToOne',
        name: 'number',
        label: 'Stock Item#',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      },
      {
        entity: 'stockItem',
        entityRelation: 'OneToOne',
        name: 'costInfo',
        label: 'Cost',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'numeric',
        fieldName: 'cost'
      },
      {
        entity: 'Location',
        entityRelation: 'OneToOne',
        name: 'code',
        label: 'Location Code',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      },
      {
        name: 'udField1',
        label: 'UDField1',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      },
      {
        name: 'udField2',
        label: 'UDField2',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      },
      {
        name: 'udField3',
        label: 'UDField3',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      },
      {
        name: 'udFieldDate1',
        label: 'UDFieldDate1',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'date'
      },
      {
        name: 'udFieldDate2',
        label: 'UDFieldDate2',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'date'
      },
      {
        name: 'udFieldDate3',
        label: 'UDFieldDate3',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'date'
      }

    ]
  },
  'users': {
    modelName: 'Users',
    labelName: 'users',
    columns: [
      // {
      //   name: 'username',
      //   label: 'user name',
      //   mappedName: '',
//        mappedNameToValidate: '',
      //   type: 'string',
      //   required: true
      // },
      {
        name: 'email',
        label: 'Email',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'person',
        entityRelation: "OneToOne",
        name: 'title',
        label: 'Title',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'firstName',
        label: 'First Name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'appRole',
        entityRelation: "OneToOne",
        name: 'name',
        label: 'Security Level',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        relatedDbField: "appRoleId"
      },
      {
        entity: 'person',
        entityRelation: "OneToOne",
        name: 'hireDate',
        label: 'Hire Date',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'date',
      },
      {
        entity: 'person',
        entityRelation: "OneToOne",
        name: 'code',
        label: 'Person ID',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        relatedDbField: "personId"
      },
      {
        entity: 'person',
        entityRelation: "OneToOne",
        name: 'leaveDate',
        label: 'Leave Date',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'date',
      },
      // {
      //   entity: 'person',
      //   entityRelation: "OneToOne",
      //   name: 'title',
      //   label: 'Title',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',
      // },
      {
        entity: 'person',
        entityRelation: "OneToOne",
        name: 'entityContact',
        fieldName: 'addressLine1',
        label: 'Address 1',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'person',
        entityRelation: "OneToOne",
        name: 'entityContact',
        fieldName: 'addressLine2',
        label: 'Address 2',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'person',
        entityRelation: "OneToOne",
        name: 'entityContact',
        fieldName: 'city',
        label: 'City',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'person',
        entityRelation: "OneToOne",
        name: 'entityContact',
        fieldName: 'state',
        label: 'State',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'person',
        entityRelation: "OneToOne",
        name: 'entityContact',
        fieldName: 'zip',
        label: 'Zip',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'person',
        entityRelation: "OneToOne",
        name: 'entityContact',
        fieldName: 'country',
        label: 'Country',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'person',
        entityRelation: "OneToOne",
        name: 'entityContact',
        fieldName: 'phone1',
        label: 'Phone 1',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'person',
        entityRelation: "OneToOne",
        name: 'entityContact',
        fieldName: 'phone2',
        label: 'Phone 2',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'person',
        entityRelation: "OneToOne",
        name: 'entityContact',
        fieldName: 'smsAddress',
        label: 'SMS Address',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'lastName',
        label: 'Last Name',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        entity: 'timezone',
        entityRelation: "OneToOne",
        name: 'name',
        label: 'Timezone',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
        relatedDbField: "timezoneId"
      },
      {
        name: 'hasComplexPassword',
        label: 'Complex Password',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'boolean',
      },
      {
        name: 'isMobileUser',
        label: 'Mobile User',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'boolean',
      },
      {
        name: 'twoFactorEnabled',
        label: 'Two Factor Login',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'boolean',
      },
      {
        name: 'importUserStatus',
        label: 'Active',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'boolean',
      },
      {
        name: 'Profile',
        label: 'Profile Picture',
        mappedName: '',
        mappedNameToValidate: '',
        type: null,
      },
      {
        name: 'department',
        label: 'Department',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },
      {
        name: 'manager',
        label: 'Manager',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string',
      },

    ],
  },
  'statuses': {
    modelName: 'Statuses',
    labelName: 'Statuses',
    columns: [
      // {
      //   name: 'statusId',
      //   label: 'Status Id',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string'
      // },
      // {
      //   name: 'description',
      //   label: 'Description',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string'
      // }
    ]
  },
  'conditions': {
    modelName: 'Conditions',
    labelName: 'Conditions',
    columns: [
      {
        name: 'conditionId',
        label: 'Condition Id',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      },
      {
        name: 'description',
        label: 'Description',
        mappedName: '',
        mappedNameToValidate: '',
        type: 'string'
      }
    ]
  },
  'asset-types': {
    modelName: 'Model Types',
    labelName: 'AssetTypes',
    columns: [
      // {
      //   name: 'modelType',
      //   label: 'Asset Type Id',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string'
      // },
      // {
      //   name: 'description',
      //   label: 'Description',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string'
      // }
    ]
  },
  'asset-models':{
    modelName: 'Models',
    labelName: 'Models',
    columns: [
      // {
      //   name: 'number',
      //   label: 'Model #',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',
      //   required: true
      // },
      // {
      //   name: 'name',
      //   label: 'Model Name',
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',
      // },
      // {
      //   entity: 'site', //table name in navigation
      //   entityRelation: 'OneToOne', //SQL relation
      //   name: 'site', //navigation start
      //   label: 'Site Code', //Title in Grid Fields Def
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',
      //   fieldName: '', //field name in navigation
      // },
      // {
      //   entity: 'modelInfo', //table name in navigation [modelInfo.cost]
      //   entityRelation: 'OneToOne', //SQL relation
      //   name: 'cost', //navigation start
      //   label: 'Cost', //Title in Grid Fields Def
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'numeric',
      //   fieldName: '', //field name in navigation
      // },
      // {
      //   entity: 'modelInfo', //table name in navigation [modelInfo.additionalDescription]
      //   entityRelation: 'OneToOne', //SQL relation
      //   name: 'additionalDescription', //navigation start
      //   label: 'Additional Description', //Title in Grid Fields Def
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',
      //   fieldName: '', //field name in navigation
      // },
      // {
      //   entity: 'modelInfo', //table name in navigation [modelInfo.modelManufacturer]
      //   entityRelation: 'OneToOne', //SQL relation
      //   name: 'modelManufacturer', //navigation start
      //   label: 'Model Manufacturer', //Title in Grid Fields Def
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',
      //   fieldName: '', //field name in navigation
      // },
      // {
      //   entity: 'modelClass', //table name in navigation [modelClass.code]
      //   entityRelation: 'OneToOne', //SQL relation
      //   name: 'code', //navigation start
      //   label: 'Model Class', //Title in Grid Fields Def
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',
      //   fieldName: '', //field name in navigation
      // },
      // {
      //   entity: 'modelInfo', //table name in navigation  [modelInfo.category.code]
      //   entityRelation: 'OneToOne', //SQL relation
      //   name: 'category', //navigation start
      //   label: 'Category ID', //Title in Grid Fields Def
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',
      //   fieldName: 'code', //field name in navigation
      // },
      // {
      //   entity: 'assetType', //table name in navigation  [assetType.modelType]
      //   entityRelation: 'OneToOne', //SQL relation
      //   name: 'assetType', //navigation start
      //   label: 'Model Type', //Title in Grid Fields Def
      //   mappedName: '',
      //   mappedNameToValidate: '',
      //   type: 'string',
      //   fieldName: 'modelType', //field name in navigation
      // },
    ],
  },
  'assets':{
      modelName: 'Asset',
      labelName: 'Asset',
      columns: [
      ]
  },
  'fundingsource': {
    modelName: 'Funding Source',
    labelName: 'Funding Source',
    columns: [
    ]
  },
  'asset-purchaseOrders':{
    modelName: 'Purchase Order',
    labelName: 'asset-purchaseOrders',
    columns: [
    ]
  },

};
